import React from "react";
import Buttons from "../../Atoms/Buttons/Buttons";
import { useNavigate } from "react-router-dom";
import styles from "./Unauthorized.module.css";
const UnauthorizedPages = ({ pages }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    if (pages?.[0]?.childPages?.length > 0) {
      navigate(pages?.[0]?.childPages?.[0]?.path);
    } else {
      navigate(pages?.[0]?.path);
    }
  };
  return (
    <div className={styles["un-auth-container"]}>
      <div className={styles["auth"]}>
        Page Not Found
        <Buttons text='Previous page' handleOnClick={handleRedirect} />
      </div>
    </div>
  );
};

export default UnauthorizedPages;
